import { useNavigate } from 'react-router-dom'

import ArrowLeftIcon from 'assets/icons/ArrowLeft.png'
import externalLinkIcon from 'assets/icons/external-link.svg'
import { Button } from 'components/Button'
import { developmentIntroParagraphs, developmentSections, heroImage, muralLink } from 'constants/DevelopmentConstants'

import { WorkstreamSection } from './WorkstreamSection'
import './development.scss'

export const Development = () => {
  const navigate = useNavigate()

  return (
    <div className="development mx-auto flex flex-col items-center gap-16">
      <div className="flex flex-col gap-10 items-center w-full">
        <h1 className="headline-xl text-center">Development</h1>

        <div className="flex gap-14 items-center w-full">
          <div className="flex flex-col gap-6 items-start w-[600px] shrink-0">
            <div className="flex flex-col gap-4 items-start w-full">
              <p className="body-m font-extrabold w-full">{developmentIntroParagraphs[0]}</p>
              {developmentIntroParagraphs.slice(1).map(paragraph => (
                <p key={paragraph} className="body-s w-full">
                  {paragraph}
                </p>
              ))}
            </div>

            <a
              href={muralLink}
              target="_blank"
              rel="noreferrer"
              className="btn-black border border-solid body-s font-bold whitespace-nowrap inline-flex items-center gap-2 px-[16px] py-[10px] min-w-24"
            >
              Mural
              <img src={externalLinkIcon} alt="" width={20} height={20} />
            </a>
          </div>

          <div className="dev-hero flex-1">
            <img src={heroImage} alt="Meaningful Brand Role framework" />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-10 items-start w-full">
        {developmentSections.map(section => (
          <WorkstreamSection key={section.key} section={section} />
        ))}
      </div>

      <div className="flex justify-center mt-6 mb-16">
        <Button
          text="Go to Insights Gathering"
          color="white"
          icon={<img src={ArrowLeftIcon} alt="Arrow Left" width="16" height="16" />}
          iconposition="left"
          className="px-[16px] py-[10px] border-2 z-[2]"
          onClick={() => navigate('/process?Insights Gathering')}
        />
      </div>
    </div>
  )
}
